module.exports = __webpack_public_path__ + "img/event2412_4_2.cbc5ab47.jpg";